import React from 'react'
import { Modal, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

// `info.input` is opt-in: when a caller supplies it, the modal renders a text
// field and passes its value to triggerAction('primary', value). Callers that
// omit it keep the original plain confirm behaviour.
class AlertModal extends React.Component {
  state = { inputValue: '' }

  componentWillReceiveProps(nextProps) {
    // Reset between openings so a previous entry never leaks into a new alert.
    if (nextProps.isShowAlert && !this.props.isShowAlert) {
      this.setState({ inputValue: '' })
    }
  }

  handleInputChange = (e) => {
    this.setState({ inputValue: e.currentTarget.value })
  }

  isInputValid() {
    const { input } = this.props.info
    if (!input || !input.required) return true
    return this.state.inputValue.trim().length > 0
  }

  render() {
    const {
      isShowAlert,
      hideAlert,
      triggerAction,
      info: { primary, secondary, input, ...info },
    } = this.props

    const isValid = this.isInputValid()

    return (
      <Modal show={isShowAlert} onHide={hideAlert} bsSize="sm">
        <Modal.Header closeButton>
          <Modal.Title>{info.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {info.description}
          {input && (
            <FormGroup className="mt-3" validationState={isValid ? null : 'error'}>
              <ControlLabel>
                {input.label}
                {input.required && <span className="text-danger"> *</span>}
              </ControlLabel>
              <FormControl
                componentClass="textarea"
                rows={3}
                value={this.state.inputValue}
                placeholder={input.placeholder}
                onChange={this.handleInputChange}
              />
            </FormGroup>
          )}
        </Modal.Body>
        <Modal.Footer>
          {info.defaultCancelButton && (
            <Button bsStyle="default" onClick={hideAlert}>
              {info.defaultCancelButtonTitle || 'Cancel'}
            </Button>
          )}
          {secondary && (
            <Button
              bsStyle={secondary.bsStyle}
              onClick={() => triggerAction('secondary', this.state.inputValue)}
            >
              {secondary.title}
            </Button>
          )}
          {primary && (
            <Button
              bsStyle={primary.bsStyle}
              disabled={!isValid}
              onClick={() => triggerAction('primary', this.state.inputValue)}
            >
              {primary.title}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    )
  }
}

export default AlertModal
